import React, { useCallback, useEffect, useRef, useState } from "react";

// import { FaPlus } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// import { AiFillEdit, AiFillEye } from "react-icons/ai";
// import { FiDelete, FiEdit } from "react-icons/fi";
import { getSector } from "helper";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import { Card, Grid } from "@mui/material";
import SearchBar from "components/SearchBar";
import CustomTable from "components/CustomTable";
import { _postApi } from "redux/action/api";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import { _fetchApi } from "redux/action/api";
import Scrollbar from "components/Tree/Scrollbar";
import {
  Button,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  // Modal,
  // ModalBody,
  // ModalHeader,
  Label,
  Spinner,
  // Row,
  // Col,
  // Table,
} from "reactstrap";
import { formatNumber } from "redux/action/api";
import CustomTypeahead from "components/CustomTypeahead";
// import { today } from "helper";
import { year } from "helper";
// import { useSelector } from "react-redux";
import { useToasts } from "helper/ToastAdapter";
import { useYear } from "useYearList";
// import { checkIfNull } from "redux/action/api";
// import { bg } from "redux/action/api";
import { FaEye, FaSearch } from "react-icons/fa";
import { SiMicrosoftexcel } from "react-icons/si";
import { MdPrint } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
import { today, weekAgo } from "redux/action/api";
import { ensureNumber } from "redux/action/api";
import * as XLSX from "xlsx";
import moment from "moment";

function ReleaseReport() {
  const years = useYear();
  const { addToast } = useToasts();
  const [activeTab, setActiveTab] = useState("report");
  const [form, setForm] = useState({
    budget_year: year,
    economic_code: "",
    economic_description: "",
    program_code: "",
    program_description: "",
    function_code: "",
    function_description: "",
    fund_code: "",
    fund_description: "",
    geo_code: "",
    geo_description: "",
    budget_amount: "",
    actual_amount: "",
    budget_type: "",
    date_from: weekAgo,
    date_to: today,
    segment: "",
    approval_type: "",
    sector_type: "",
  });
  const [searchText, setSearchText] = useState("");
  const [results, setResults] = useState();
  const [loading, setLoading] = useState(false);
  const [print, setPrint] = useState(false);
  const [showBulkPreview, setShowBulkPreview] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [results4, setResult4] = useState([]);

  // ---------- Release Enquiry state ----------
  const [enquiryForm, setEnquiryForm] = useState({
    admin_code: "",
    mda_code: "",
    buget_year: year,
    economic_code: "",
    program_code: "",
  });
  const [enquiryResults, setEnquiryResults] = useState([]);
  const [enquiryLoading, setEnquiryLoading] = useState(false);
  const [enquirySearchText, setEnquirySearchText] = useState("");

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const fields = [
    {
      title: "Release Date",
      custom: true,
      component: (ite) => (
        <div> {moment(ite.approval_date).format("DD-MM-YYYY")}</div>
      ),
    },
    { title: "MDA Code", custom: true, component: (ite) => ite.mda_code },
    {
      title: "MDA Name",
      custom: true,
      component: (ite) => <div> {ite.mda_name}</div>,
    },
    {
      title: "Economic Code",
      custom: true,
      component: (item) => item.economic_code,
    },
    {
      title: "Economic Description",
      custom: true,
      component: (ite) => ite.description_code,
    },

    {
      title: "Program Code",
      custom: true,
      component: (ite) => ite.program_code,
    },
    // {
    //   title: "Program Description",
    //   custom: true,
    //   component: (ite) => ite.program_description,
    // },
    // {
    //   title: "Functional code",
    //   custom: true,
    //   component: (ite) => ite.function_code,
    // },

    // { title: "Geo code", custom: true, component: (ite) => ite.geo_code },
    // {
    //   title: "Geo Description",
    //   custom: true,
    //   component: (ite) => ite.geo_description,
    // },

    {
      title: "Amount (₦)",
      custom: true,
      component: (ite, idx) => (
        <div style={{ float: "right" }}>
          {formatNumber(ensureNumber(ite.amount))}
        </div>
      ),
    },
    {
      title: "Approval status",
      custom: true,
      component: (ite, idx) => <div>{ite.approval_status}</div>,
    },
    {
      title: "Approval No",
      custom: true,
      component: (ite, idx) => <div>{ite.approval_no}</div>,
    },
    // {
    //   title: "MOPB Bal. (₦)",
    //   custom: true,
    //   component: (ite, idx) => (
    //     <div style={{ float: "right" }}>
    //       {formatNumber(ensureNumber(ite.balance))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Acct. Bal. (₦)",
    //   custom: true,
    //   component: (ite, idx) => (
    //     <div style={{ float: "right" }}>
    //       {formatNumber(ensureNumber(ite.acct_balance))}
    //     </div>
    //   ),
    // },
    // {
    //   title: "Status",
    //   custom: true,
    //   component: (ite, idx) => <div>{ite.payment_status}</div>,
    // },
  ];

  const handleChange = ({ target: { name, value } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  let query_type = form.approval_type === "" ? "reports" : "by_type";

  const getBudgetNew = useCallback(() => {
    setLoading(true);
    _postApi(
      `/releases-reports`,
      { ...form, query_type },
      (res) => {
        setResults(res.results);
        // console.log(res, "DATA");

        setLoading(false);
      },
      (err) => {
        console.log(err);
        setLoading(false);
      },
    );
  }, [
    query_type,
    form.mda_name,
    form.approval_type,
    form.date_from,
    form.date_to,
  ]);

  useEffect(() => {
    getBudgetNew();
  }, [getBudgetNew]);

  const handleChanges = ({ target: { value, name } }) => {
    setForm((p) => ({ ...p, [name]: value }));
  };

  const total = results?.reduce(
    (total, item) => total + parseFloat(item?.amount),
    0,
  );
  // const totalCR = results?.reduce(
  //   (total, item) => total + parseFloat(item?.cr),
  //   0,
  // );
  // const totalMOPBCR = results?.reduce(
  //   (total, item) => total + parseFloat(item?.mob_amount || 0),
  //   0,
  // );

  useEffect(() => {
    getSector({ type: "mdas", sector_type: form.sector_type }, "mdas", (d) => {
      setResult4(d);
    });
  }, [form.sector_type]);

  let aheadData = results4?.map((i) => ({
    head: `${i.head}-${i.description}`,
    description: i.description,
    code: i.head,
  }));

  let data = [];

  results?.forEach((item) => {
    if (
      searchText &&
      ((item.economic_description &&
        item.economic_description
          ?.toLowerCase()
          .indexOf(searchText?.toLowerCase()) === -1) ||
        (item.economic_code &&
          item.economic_code
            ?.toLowerCase()
            .indexOf(searchText?.toLowerCase()) === -1) ||
        (item.mda_code &&
          item.mda_code?.toLowerCase().indexOf(searchText?.toLowerCase()) ===
            -1) ||
        (item.mda_name &&
          item.mda_name?.toLowerCase().indexOf(searchText?.toLowerCase()) ===
            -1))
    )
      return;
    else data.push(item);
  });

  const open = () => {
    setPrint(!print);
  };

  const close = () => {
    setPrint(false);
  };

  // ---------- Release Enquiry handlers ----------
  const handleEnquiryChange = ({ target: { name, value } }) => {
    setEnquiryForm((p) => ({ ...p, [name]: value }));
  };

  const handleEnquirySearch = () => {
    if (
      !enquiryForm.admin_code &&
      !enquiryForm.mda_code &&
      !enquiryForm.buget_year &&
      !enquiryForm.economic_code &&
      !enquiryForm.program_code
    ) {
      addToast("Please enter at least one search filter", {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }
    setEnquiryLoading(true);
    // Use mda_code if provided (overrides admin_code field)
    const payload = {
      ...enquiryForm,
      admin_code: enquiryForm.mda_code || enquiryForm.admin_code,
    };
    _postApi(
      "/release-enquiry",
      payload,
      (res) => {
        setEnquiryResults(res.results || []);
        setEnquiryLoading(false);
      },
      (err) => {
        console.error(err);
        addToast("Failed to fetch release enquiry data", {
          appearance: "error",
          autoDismiss: true,
        });
        setEnquiryLoading(false);
      },
    );
  };

  const handleExportExcel = () => {
    if (filteredEnquiryResults.length === 0) return;

    const rows = filteredEnquiryResults.map((item) => {
      const dr = ensureNumber(item.dr);
      const cr = ensureNumber(item.cr);
      return {
        "Entries Date": item.entries_date
          ? moment(item.entries_date).format("DD-MM-YYYY")
          : "",
        "MDA Code": item.mda_code || "",
        Description: item.description || "",
        "Economic Code": item.economic_code || "",
        "Program Code": item.program_code || "",
        "Fund Code": item.fund_code || "",
        "DR (₦)": dr,
        "CR (₦)": cr,
        "Bal (₦)": dr - cr,
        "Budget Year": item.buget_year || "",
        "Approval No": item.approval_no || "",
        "Batch No": item.batch_no || "",
        "Payment Status": item.payment_status || "",
        "Reference No": item.reference_number || "",
      };
    });

    // Totals row
    rows.push({
      "Entries Date": "",
      "MDA Code": "",
      Description: "TOTAL",
      "Economic Code": "",
      "Program Code": "",
      "Fund Code": "",
      "DR (₦)": enquiryTotalDR,
      "CR (₦)": enquiryTotalCR,
      "Bal (₦)": enquiryTotalBal,
      "Budget Year": "",
      "Approval No": "",
      "Batch No": "",
      "Payment Status": "",
      "Reference No": "",
    });

    const ws = XLSX.utils.json_to_sheet(rows);

    // Column widths
    ws["!cols"] = [
      { wch: 14 }, // Entries Date
      { wch: 16 }, // MDA Code
      { wch: 35 }, // Description
      { wch: 14 }, // Economic Code
      { wch: 14 }, // Program Code
      { wch: 12 }, // Fund Code
      { wch: 16 }, // DR
      { wch: 16 }, // CR
      { wch: 16 }, // Bal
      { wch: 12 }, // Budget Year
      { wch: 14 }, // Approval No
      { wch: 12 }, // Batch No
      { wch: 16 }, // Payment Status
      { wch: 18 }, // Reference No
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Release Enquiry");

    const filename = `Release_Enquiry_${enquiryForm.mda_code || "ALL"}_${enquiryForm.buget_year || "ALL"}_${moment().format("YYYYMMDD")}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  const filteredEnquiryResults = enquiryResults.filter((item) => {
    if (!enquirySearchText) return true;
    const q = enquirySearchText.toLowerCase();
    return (
      (item.description && item.description.toLowerCase().includes(q)) ||
      (item.mda_code && item.mda_code.toLowerCase().includes(q)) ||
      (item.economic_code && item.economic_code.toLowerCase().includes(q)) ||
      (item.program_code && item.program_code.toLowerCase().includes(q)) ||
      (item.approval_no && String(item.approval_no).toLowerCase().includes(q))
    );
  });

  const enquiryTotalDR = filteredEnquiryResults.reduce(
    (sum, item) => sum + ensureNumber(item.dr),
    0,
  );
  const enquiryTotalCR = filteredEnquiryResults.reduce(
    (sum, item) => sum + ensureNumber(item.cr),
    0,
  );
  const enquiryTotalBal = enquiryTotalDR - enquiryTotalCR;

  const enquiryFields = [
    {
      title: "Entries Date",
      custom: true,
      component: (item) =>
        item.entries_date
          ? moment(item.entries_date).format("DD-MM-YYYY")
          : "---",
    },
    { title: "MDA Code", custom: true, component: (item) => item.mda_code },
    {
      title: "Description",
      custom: true,
      component: (item) => item.description,
    },
    {
      title: "Economic Code",
      custom: true,
      component: (item) => item.economic_code,
    },
    {
      title: "Program Code",
      custom: true,
      component: (item) => item.program_code || "---",
    },
    {
      title: "DR (₦)",
      custom: true,
      component: (item) => {
        const val = ensureNumber(item.dr);
        return (
          <div
            style={{
              float: "right",
              color: val > 0 ? "#2e7d32" : "inherit",
              fontWeight: val > 0 ? "bold" : "normal",
            }}
          >
            {formatNumber(val)}
          </div>
        );
      },
    },
    {
      title: "CR (₦)",
      custom: true,
      component: (item) => (
        <div style={{ float: "right" }}>
          {formatNumber(ensureNumber(item.cr))}
        </div>
      ),
    },

    {
      title: "Approval No",
      custom: true,
      component: (item) => item.approval_no || "---",
    },

    {
      title: "Payment Status",
      custom: true,
      component: (item) => item.payment_status || "---",
    },
  ];

  // Bulk preview functionality
  const handleBulkPreview = () => {
    if (data.length === 0) {
      addToast("No data to preview", {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }

    setShowBulkPreview(true);
  };

  // Render the bulk preview with webview
  const renderBulkPreview = () => {
    return (
      <div>
        {/* Header with back and print buttons */}
        <div
          className="no-print"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            marginBottom: "20px",
          }}
        >
          <Button
            color="secondary"
            onClick={() => setShowBulkPreview(false)}
            style={{ fontWeight: 500 }}
          >
            ← Back to Report
          </Button>
          <h5 style={{ margin: 0, color: "#333" }}>
            Release Report Preview - {data.length} Record
            {data.length !== 1 ? "s" : ""}
          </h5>
          <Button
            color="success"
            onClick={() => window.print()}
            style={{
              fontWeight: 500,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <MdPrint size="18px" />
            Print Report
          </Button>
        </div>

        {/* Render the report in webview format */}
        <div
          id="bulk-print-container"
          style={{ backgroundColor: "#f5f5f5", padding: "20px" }}
          className="print-container"
        >
          <style>{`
            @media print {
              @page {
                margin: 0;
                size: A4;
              }
              body * {
                visibility: hidden;
              }
              #bulk-print-container, #bulk-print-container * {
                visibility: visible;
              }
              #bulk-print-container {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: white !important;
                padding: 0 !important;
              }
              .print-page {
                page-break-after: always;
                page-break-inside: avoid;
                margin: 0 !important;
                padding: 0 !important;
                background: white !important;
                display: block !important;
                width: 100% !important;
                height: auto !important;
              }
              .print-page:last-child {
                page-break-after: auto;
              }
              .no-print {
                display: none !important;
              }
              /* Hide any fixed positioned elements that might show download buttons */
              div[style*="position: fixed"] {
                display: none !important;
              }
              /* Hide any overlay buttons */
              button {
                display: none !important;
              }
              /* Ensure clean print output */
              * {
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
              /* Remove any extra spacing or margins that cause empty pages */
              .print-page > div {
                margin: 0 !important;
                padding: 0 !important;
                background: white !important;
                box-shadow: none !important;
                border: none !important;
              }
              /* Ensure PDF components fill the page properly */
              .print-page > div > div {
                margin: 0 auto !important;
                box-shadow: none !important;
                background: white !important;
                padding: 0 !important;
              }
              /* Remove any container backgrounds and shadows */
              .print-container {
                background: white !important;
                padding: 0 !important;
                margin: 0 !important;
              }
              /* Ensure proper spacing between content */
              .print-page + .print-page {
                margin-top: 0 !important;
                padding-top: 0 !important;
              }
            }
            
            @media screen {
              .print-page {
                margin-bottom: 40px;
              }
              .print-page:last-child {
                margin-bottom: 0;
              }
            }
          `}</style>

          <div className="print-page">
            <div
              style={{
                width: "210mm",
                minHeight: "297mm",
                padding: "30px 40px",
                fontFamily: "Arial, sans-serif",
                fontSize: "11px",
                lineHeight: "1.4",
                backgroundColor: "white",
                margin: "0 auto 20px",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
              }}
            >
              {/* Header */}
              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <img
                  src={require("../../assets/images/pngwing.com.png")}
                  style={{
                    width: "100px",
                    height: "60px",
                    marginBottom: "8px",
                  }}
                  alt="logo"
                />

                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: "4px",
                  }}
                >
                  MINISTRY OF BUDGET & ECONOMIC PLANNING
                </div>
                <div style={{ fontSize: "12px", marginBottom: "2px" }}>
                  Old Government House Office Complex, Katsina
                </div>
                <div style={{ fontSize: "12px" }}>P.MB 2132, KATSINA</div>
              </div>

              {/* Title */}
              <div
                style={{
                  textAlign: "center",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  fontSize: "14px",
                  marginBottom: "20px",
                }}
              >
                RELEASES REPORT
              </div>

              {/* Date Range */}
              <div style={{ marginBottom: "15px", fontSize: "12px" }}>
                <strong>Period:</strong>{" "}
                {moment(form.date_from).format("DD-MM-YYYY")} to{" "}
                {moment(form.date_to).format("DD-MM-YYYY")}
              </div>

              {/* Summary */}
              <div style={{ marginBottom: "20px", fontSize: "12px" }}>
                <div>
                  <strong>Total DR:</strong> ₦{total?.toLocaleString()}
                </div>
                {/* <div>
                  <strong>Total CR:</strong> ₦{totalCR?.toLocaleString()}
                </div>
                <div>
                  <strong>Total MOPB CR:</strong> ₦
                  {totalMOPBCR?.toLocaleString()}
                </div> */}
                <div>
                  <strong>Total Records:</strong> {data.length}
                </div>
              </div>

              {/* Table */}
              <table
                style={{
                  width: "100%",
                  border: "1px solid black",
                  borderCollapse: "collapse",
                  fontSize: "9px",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f0f0f0" }}>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      MDA Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Economic Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Description
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Program Code
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Amount (₦)
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        textAlign: "center",
                      }}
                    >
                      Approval no
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {moment(item.approval_date).format("DD-MM-YYYY")}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.mda_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.economic_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.description_code}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          fontSize: "8px",
                        }}
                      >
                        {item.program_code || "---"}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.amount))}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.approval_status))}
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          padding: "3px",
                          textAlign: "right",
                          fontSize: "8px",
                        }}
                      >
                        {formatNumber(ensureNumber(item.approval_no))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Footer */}
              <div
                style={{
                  marginTop: "30px",
                  textAlign: "center",
                  fontSize: "10px",
                }}
              >
                <div>Generated on: {moment().format("DD-MM-YYYY HH:mm")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DashboardLayout>
      {form.mda_name && (
        <center>
          <h2>{/* {form.mda_code} - {form.mda_name} */}</h2>
        </center>
      )}
      {showBulkPreview ? (
        renderBulkPreview()
      ) : (
        <MDBox pt={1} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography
                    variant="h5"
                    color="white"
                    className="text-center"
                  >
                    Releases Report
                  </MDTypography>
                </MDBox>

                <MDBox>
                  {/* Tab navigation */}
                  <Nav
                    tabs
                    style={{
                      marginLeft: 15,
                      marginTop: 15,
                      borderBottom: "2px solid #e0e0e0",
                    }}
                  >
                    <NavItem>
                      <NavLink
                        active={activeTab === "report"}
                        onClick={() => setActiveTab("report")}
                        style={{
                          cursor: "pointer",
                          color: activeTab === "report" ? "#fff" : "#666",
                          backgroundColor:
                            activeTab === "report"
                              ? "#51ce5bff"
                              : "transparent",
                          borderRadius: "8px 8px 0 0",
                          fontWeight:
                            activeTab === "report" ? "bold" : "normal",
                          padding: "5px 20px",
                          border:
                            activeTab === "report"
                              ? "2px solid #bbb6d0ff"
                              : "2px solid transparent",
                          borderBottom:
                            activeTab === "report"
                              ? "none"
                              : "2px solid transparent",
                          marginBottom: "-2px",
                        }}
                      >
                        Release Report
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        active={activeTab === "enquiry"}
                        onClick={() => setActiveTab("enquiry")}
                        style={{
                          cursor: "pointer",
                          color: activeTab === "enquiry" ? "#fff" : "#666",
                          backgroundColor:
                            activeTab === "enquiry"
                              ? "#51ce5bff"
                              : "transparent",
                          borderRadius: "8px 8px 0 0",
                          fontWeight:
                            activeTab === "enquiry" ? "bold" : "normal",
                          padding: "5px 20px",
                          border:
                            activeTab === "enquiry"
                              ? "2px solid #51cbce"
                              : "2px solid transparent",
                          borderBottom:
                            activeTab === "enquiry"
                              ? "none"
                              : "2px solid transparent",
                          marginBottom: "-2px",
                        }}
                      >
                        Release Enquiry
                      </NavLink>
                    </NavItem>
                  </Nav>

                  <TabContent activeTab={activeTab}>
                    {/* ===== TAB 1: Release Report (existing) ===== */}
                    <TabPane tabId="report">
                      <MDBox pt={0}>
                        <div className=" row p-3">
                          <div className="col-md-4 mb-3">
                            <CustomTypeahead
                              labelKey="head"
                              label="Select MDA"
                              options={aheadData}
                              onChange={(s) => {
                                if (s.length) {
                                  setForm((p) => ({
                                    ...p,
                                    mda_code: s[0].code,
                                    mda_name: s[0].description,
                                  }));
                                } else {
                                  setForm((p) => ({
                                    ...p,
                                    mda_code: "",
                                    mda_name: "",
                                  }));
                                }
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <Label></Label>
                            <SearchBar
                              placeholder="Search By code or description"
                              filterText={searchText}
                              onChange={handleSearchChange}
                            />
                          </div>
                          <div className="col-md-3">
                            <Label>Date From</Label>
                            <Input
                              type="date"
                              value={form.date_from}
                              name="date_from"
                              onChange={handleChanges}
                            />
                          </div>
                          <div className="col-md-2">
                            <Label>Date To</Label>
                            <Input
                              type="date"
                              value={form.date_to}
                              name="date_to"
                              onChange={handleChanges}
                            />
                          </div>
                          <div className="row">
                            <div className="col-md-8">
                              <span style={{ marginRight: "15px" }}>
                                <b>TOTAL AMOUNT : </b> ₦
                                {total?.toLocaleString()}
                              </span>
                            </div>
                            <div className="col-md-4">
                              <Button
                                color="success"
                                className="mt-0"
                                onClick={handleBulkPreview}
                                disabled={isPrinting || data.length === 0}
                                style={{
                                  fontWeight: 500,
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  float: "right",
                                }}
                              >
                                {isPrinting ? (
                                  <>
                                    <Spinner size="sm" />
                                    Loading...
                                  </>
                                ) : (
                                  <>
                                    <FaEye size="16px" />
                                    Preview Report ({data.length})
                                  </>
                                )}
                              </Button>
                            </div>
                          </div>

                          {loading && (
                            <div className="loading-container text-center">
                              <Spinner
                                color="primary"
                                style={{ marginTop: "20px" }}
                              />{" "}
                              Loading...
                            </div>
                          )}
                          <Scrollbar>
                            <CustomTable
                              fields={fields}
                              data={data}
                              type="approve"
                            />
                          </Scrollbar>
                        </div>
                      </MDBox>
                    </TabPane>

                    {/* ===== TAB 2: Release Enquiry ===== */}
                    <TabPane tabId="enquiry">
                      <MDBox pt={0}>
                        <div className="row p-3">
                          {/* Filter row: MDA Code → Economic Code → Program Code → Budget Year → Search */}
                          <div className="col-md-3 mb-3">
                            <Label>MDA Code</Label>
                            <Input
                              type="text"
                              name="mda_code"
                              placeholder="e.g. 023800100104"
                              value={enquiryForm.mda_code}
                              onChange={handleEnquiryChange}
                            />
                          </div>
                          <div className="col-md-2 mb-3">
                            <Label>Economic Code</Label>
                            <Input
                              type="text"
                              name="economic_code"
                              placeholder="e.g. 21010102"
                              value={enquiryForm.economic_code}
                              onChange={handleEnquiryChange}
                            />
                          </div>
                          <div className="col-md-2 mb-3">
                            <Label>Program Code</Label>
                            <Input
                              type="text"
                              name="program_code"
                              placeholder="e.g. 0001"
                              value={enquiryForm.program_code}
                              onChange={handleEnquiryChange}
                            />
                          </div>
                          <div className="col-md-2 mb-3">
                            <Label>Budget Year</Label>
                            <Input
                              type="select"
                              name="buget_year"
                              value={enquiryForm.buget_year}
                              onChange={handleEnquiryChange}
                            >
                              <option value="">-- All Years --</option>
                              {years.map((y) => (
                                <option key={y} value={y}>
                                  {y}
                                </option>
                              ))}
                            </Input>
                          </div>
                          <div className="col-md-3 mb-3 d-flex align-items-end">
                            <Button
                              color="success"
                              onClick={handleEnquirySearch}
                              disabled={enquiryLoading}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                width: "100%",
                                justifyContent: "center",
                                backgroundColor: "#51ce5bff",
                                borderColor: "#51ce5bff",
                              }}
                            >
                              {enquiryLoading ? (
                                <Spinner size="sm" />
                              ) : (
                                <FaSearch size="14px" />
                              )}
                              {enquiryLoading ? "" : "Search"}
                            </Button>
                          </div>

                          {/* Summary + filter row */}
                          {enquiryResults.length > 0 && (
                            <div className="col-12 mb-2">
                              <div className="row align-items-center">
                                <div className="col-md-5">
                                  <SearchBar
                                    placeholder="Filter results..."
                                    filterText={enquirySearchText}
                                    onChange={(e) =>
                                      setEnquirySearchText(e.target.value)
                                    }
                                  />
                                </div>
                                <div
                                  className="col-md-7 d-flex align-items-center"
                                  style={{ gap: "16px", flexWrap: "wrap" }}
                                >
                                  <span>
                                    <b>Total DR: </b>
                                    <span
                                      style={{
                                        color: "#2e7d32",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ₦{enquiryTotalDR.toLocaleString()}
                                    </span>
                                  </span>
                                  <span>
                                    <b>Total CR: </b>₦
                                    {enquiryTotalCR.toLocaleString()}
                                  </span>
                                  <span>
                                    <b>Balance: </b>
                                    <span
                                      style={{
                                        color:
                                          enquiryTotalBal > 0
                                            ? "#2e7d32"
                                            : enquiryTotalBal < 0
                                              ? "#c62828"
                                              : "inherit",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      ₦{enquiryTotalBal.toLocaleString()}
                                    </span>
                                  </span>
                                  <span>
                                    <b>Records: </b>
                                    {filteredEnquiryResults.length}
                                  </span>
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={handleExportExcel}
                                    disabled={
                                      filteredEnquiryResults.length === 0
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      backgroundColor: "#1a7a3a",
                                      borderColor: "#1a7a3a",
                                    }}
                                  >
                                    <SiMicrosoftexcel size="15px" />
                                    Export Excel
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Results table */}
                          {enquiryLoading ? (
                            <div className="text-center col-12 mt-3">
                              <Spinner color="success" /> Loading...
                            </div>
                          ) : (
                            <Scrollbar>
                              <CustomTable
                                fields={enquiryFields}
                                data={filteredEnquiryResults}
                              />
                            </Scrollbar>
                          )}

                          {!enquiryLoading && enquiryResults.length === 0 && (
                            <div
                              className="text-center col-12 mt-3"
                              style={{ color: "#999" }}
                            >
                              Select MDA and/or Year then click Search to fetch
                              all release entries.
                            </div>
                          )}
                        </div>
                      </MDBox>
                    </TabPane>
                  </TabContent>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default ReleaseReport;
